import { ZInfiniteScroll } from '@zoryn/components/infinite-scroll'
import { ZLoading } from '@zoryn/components/loading'
import { ZMessage } from '@zoryn/components/message'
import { ZMessageBox } from '@zoryn/components/message-box'
import { ZNotification } from '@zoryn/components/notification'
import { ZPopoverDirective } from '@zoryn/components/popover'

import type { Plugin } from 'vue'

export default [
  ZInfiniteScroll,
  ZLoading,
  ZMessage,
  ZMessageBox,
  ZNotification,
  ZPopoverDirective,
] as Plugin[]
